import * as React from 'react';
import ClientsTable from '../components/ClientsTable';
import ClientModal from '../components/ClientModal';
import { Default } from './Default';
import { usersCompose, IUserComponentProps, User, IUser, clearUser } from '../shared/users';
import { IState } from '../shared';

class Clients extends React.Component<IUserComponentProps, IState<IUser>> {
  state: IState<IUser> = { filters: new Map() };

  render () {
    const clients: IUser[] = Array.from(this.state.filters.values()).reduce(
      (prev: IUser[], item) => prev.filter(item),
      ( this.props.data.users || [] )
        .filter(user => User.hasType(user,'CLIENT'))
    );
    return (
      <Default
        title={'Клиенты'}
        addable={true}
        clearEdit={{ ...clearUser, types: [ 'CLIENT' ] }}
        defaultSortKey={'name'}
        items={clients}
        table={props => (
          <ClientsTable
            items={clients}
            isLoading={this.props.data.loading}
            {...props}
          />
        )}
        modal={props => (
          <ClientModal heading={`${props.isAddModalOpen ? 'Добавить' : 'Редактировать'} клиента`} {...props} />
        )}
        onSave={(item: IUser, isAddModalOpen: boolean) =>
          isAddModalOpen
            ? this.props.create({ variables: { data: User.format(item) } })
            : this.props.update({ variables: { where: { id: item.id }, data: User.format(item) } })
        }
        onDelete={(items: IUser[]) =>
          this.props.deleteMany({ variables: { where: { id_in: items.map(item => item.id as string) } } })
        }
        onSearch={(text: string) =>
          this.setState({
            filters: this.state.filters.set('search', item =>
              [
                item.name,
                item.phone,
                item.email,
              ]
                .join('')
                .toUpperCase()
                .replace(/ /g, '')
                .includes(text.toUpperCase())
            )
          })
        }
      />
    );
  }
}

export default usersCompose(Clients);
